import { Box } from "@mui/material";

import EventCard from "../../../../../shared/Events/EventCard/EventCard";

import { EventPostCardProps } from "../../../types/components/props.type";

const EventPostCard = ({ post: { event } }: EventPostCardProps) => {
  return (
    <Box sx={{ padding: "0 16px" }}>
      <EventCard event={event} />
    </Box>
  );
};

export default EventPostCard;
